// extracted by mini-css-extract-plugin
module.exports = {"root":"IconList_root__bpdxN"};